import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { canAccessEmergency } from '../data/turkeyProvinces'

export default function PrivateRoute({ children, adminOnly = false, emergencyOnly = false }) {
  const {
    currentUser,
    userRole,
    userStatus,
    loading
  } = useAuth()

  // React Router konum bilgisini yakalayalım
  const location = useLocation()

  // 1) Eğer hala loading ise, henüz kullanıcı bilgilerini bilmiyoruz demektir
  if (loading) {
    return <div>Veri yükleniyor...</div>
  }

  // 2) Kullanıcı henüz yoksa (yani giriş yapmamışsa) /login'e yönlendir
  if (!currentUser || currentUser.isAnonymous) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    )
  }

  // Pasife alınan kullanıcılar korumalı sayfalara erişemez.
  if (userStatus === 'passive') {
    return (
      <Navigate
        to="/login"
        replace
        state={{ accountPassive: true }}
      />
    )
  }

  // 3) adminOnly bir rota ise ve kullanıcı admin değilse /'a yönlendir
  if (adminOnly && userRole !== 'admin') {
    return <Navigate to="/" replace />
  }

  if (emergencyOnly && !canAccessEmergency(currentUser, userStatus)) {
    return <Navigate to="/" replace />
  }

  // 4) Kullanıcının nickname'i yoksa, ancak şu an /profile sayfasında değilse, oraya yönlendir
  const hasNickname = currentUser.nickname && currentUser.nickname.trim() !== ''
  if (!hasNickname && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />
  }

  // 5) Tüm şartlar sağlandığında, hedef bileşeni render et
  return children
}
